import React from 'react'

import { Layout, Column, Section } from '@/components/layout'
import { Link } from '@/components/common'
import routes from '@/routes'

const pageId = 'referral'

export default function Referral() {
  return (
    <Layout.Content>
      <Section>
        <Column center textCenter>
          <h1>Program no longer available</h1>
          <Link to={routes.index}>Back to home</Link>
        </Column>
      </Section>
    </Layout.Content>
  )
}

Referral.layoutProps = {
  pageId,
  logoOnlyHeader: true,
  showFooter: false,
  shouldRobotsIndex: false,
}
